export default __webpack_public_path__ + "static/media/Scoop.5f99604c.jpg";